import type { StylePropertiesTypes } from '@wix/document-services-types'
import { atomicStylePropsConverterMap } from '../../atomics/atomicPropsToCss'
import { colorConverterMap } from '../Color/colorPropsToCss'

/** Internal Converters */
const shadowConverter = (prop: StylePropertiesTypes.Shadow | StylePropertiesTypes.BoxShadowItem) => {
	const { offsetX: offsetXProp, offsetY: offsetYProp, blurRadius: blurRadiusProp, color: colorProp } = prop

	const offsetX = offsetXProp && atomicStylePropsConverterMap.Length(offsetXProp)
	const offsetY = offsetYProp && atomicStylePropsConverterMap.Length(offsetYProp)
	const blurRadius = blurRadiusProp && atomicStylePropsConverterMap.Length(blurRadiusProp)
	const color = colorProp && colorConverterMap[colorProp.type](colorProp)

	return {
		offsetX,
		offsetY,
		blurRadius,
		color,
		[prop.type]:
			'--var(--{propName}-offsetX) --var(--{propName}-offsetY) --var(--{propName}-blurRadius) --var(--{propName}-color)',
	}
}

const boxShadowConverter = (prop: StylePropertiesTypes.BoxShadowItem) => {
	const { offsetX, offsetY, blurRadius, color } = shadowConverter(prop)
	const { spreadRadius: spreadRadiusProp, position: positionProp } = prop

	const spreadRadius = spreadRadiusProp && atomicStylePropsConverterMap.Length(spreadRadiusProp)
	const position = positionProp && atomicStylePropsConverterMap.Keyword(positionProp)

	return {
		offsetX,
		offsetY,
		blurRadius,
		color,
		spreadRadius,
		position,
		[prop.type]:
			'--var(--{propName}-offsetX) --var(--{propName}-offsetY) --var(--{propName}-blurRadius) --var(--{propName}-spreadRadius) --var(--{propName}-position) --var(--{propName}-color)',
	}
}

/** External Map */
export const shadowConverterMap = {
	Shadow: shadowConverter,
	BoxShadow: boxShadowConverter,
}
